import {PageableDto} from "../pagination/PagingFilterDto";
import {SortableDto} from "../pagination/SortingFilterDto";
import {IsdsMessageState} from "../message/IsdsMessageApiClient";
import {Axios} from "axios";
import {PageableResultListDto} from "../pagination/PageableResultListDto";

export interface IsdsMessageStateDto {
    id: number;
    messageId?: string;
    type?: IsdsMessageState;
    changeTime?: Date;

    statusCode?: number;
    errorCode?: string;
    errorMessage?: string;
}

export interface IsdsMessageStateFilterDto extends PageableDto, SortableDto {
    messageId?: string;
    messageRecipient?: string;

    stateType?: IsdsMessageState;

    statusCode?: string;
    errorCode?: string;

    changedSince?: string;
    changedTo?: string;
}

export class IsdsMessageStateApiClient {

    constructor(private readonly axios: Axios) {
    }

    findById(stateId: number): Promise<IsdsMessageStateDto | undefined> {
        return new Promise((resolve, reject) => {
            this.axios.get<IsdsMessageStateDto | undefined>(`/states/${stateId}`)
                .then((response) => resolve(response.data))
                .catch((error) => {
                    if (error?.response?.status === 404) {
                        resolve(undefined);
                    }
                    reject(error);
                });
        });
    }

    findByFilter(filter: IsdsMessageStateFilterDto): Promise<PageableResultListDto<IsdsMessageStateDto>> {
        return new Promise((resolve, reject) => {
            this.axios.post<PageableResultListDto<IsdsMessageStateDto>>("/states:search", filter)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    countByFilter(filter: IsdsMessageStateFilterDto): Promise<number> {
        return new Promise((resolve, reject) => {
            this.axios.post<number>("/states:search-count", filter)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

}
